exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.inform[data-v-29898e6a] {\n  position: fixed;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  z-index: 99999;\n  padding: 1.25rem 1rem 0.75rem;\n  border-top-left-radius: 0.4rem;\n  border-top-right-radius: 0.4rem;\n}\n.btn[data-v-29898e6a] {\n  margin: 1rem auto 0;\n  display: block;\n}", ""]);

// exports
